var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import PlaybackList from "./PlaybackList";
import PlaybackHistory from "./PlaybackHistory";
import { AUTOREPLAY_KEY, SHUFFLE_KEY, PlayerState, AddToHistory, HQ_KEY } from "./types";
import Player from "./Player";
var uuidv4 = require('uuid/v4');
/**
 * This class manages playback of various types of lists & tracks
 */
var PlaybackManager = /** @class */ (function () {
    function PlaybackManager() {
        // Properties
        this._playbackStateListeners = {};
        this._playbackConfigListeners = {};
        this._playbackContentManager = new PlaybackList();
        this.storeHQConfig = false;
        this._playbackConfig = {
            shuffle: false,
            autorepeat: false,
            hq: localStorage[HQ_KEY] == 'true'
        };
        this.playbackConfig = {
            shuffle: (localStorage[SHUFFLE_KEY] == 'true'),
            autorepeat: (localStorage[AUTOREPLAY_KEY] == 'true'),
            hq: this.playbackConfig.hq
        };
    }
    ;
    /**
     * This returns the shared instance to use as the global PlaybackManager
     */
    PlaybackManager.getInstance = function () {
        if (PlaybackManager.instance) {
            return PlaybackManager.instance;
        }
        PlaybackManager.instance = new PlaybackManager();
        return PlaybackManager.getInstance();
    };
    // Playback Configuration
    /**
     * This function starts playback of a track
     * @param trackData - The info about the track to play
     * @param resolveMedia - A function that resolves media urls if not provided in trackData
     * @param startPlayback - Defines if content should only be prepared but not played yet
     */
    PlaybackManager.prototype.startTrack = function (trackData, resolveMedia, startPlayback) {
        if (startPlayback === void 0) { startPlayback = true; }
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var track, data, mediaToPlay, playbackInfo, error_1;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (trackData == undefined) {
                            return [2 /*return*/, false];
                        }
                        track = trackData.track;
                        if (track === undefined) {
                            track = trackData.album.media[0];
                        }
                        if (!track) {
                            return [2 /*return*/, this.forward()];
                        }
                        data = Object.assign({}, trackData, { track: track, playbackInfo: track.stream_info });
                        switch (trackData.playlist.historyMode()) {
                            case AddToHistory.ALL:
                            case AddToHistory.GLOBAL_ONLY:
                            default:
                                PlaybackHistory.getInstance().addTrack(data);
                                break;
                            case AddToHistory.LOCAL_ONLY:
                                break;
                        }
                        mediaToPlay = data.track;
                        if (!mediaToPlay) return [3 /*break*/, 4];
                        if (((_a = this.playbackState) === null || _a === void 0 ? void 0 : _a.media) && ((_b = this.playbackState) === null || _b === void 0 ? void 0 : _b.progress)) {
                            PlaybackManager.getPlaybackInfo && PlaybackManager.getPlaybackInfo((_d = (_c = this.playbackState) === null || _c === void 0 ? void 0 : _c.media) === null || _d === void 0 ? void 0 : _d.track.id, (_e = this.playbackState) === null || _e === void 0 ? void 0 : _e.progress);
                        }
                        this.setPlaybackState({
                            media: {
                                playlist: data.playlist,
                                track: mediaToPlay,
                                album: data.album,
                                playbackInfo: data.playbackInfo
                            },
                            media_type: 'audio',
                            state: startPlayback ? PlayerState.Loading : PlayerState.Paused
                        }, data, true);
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (resolveMedia || new Promise(function (resolve, reject) {
                                if (data.playbackInfo) {
                                    resolve(data.playbackInfo);
                                }
                            }))];
                    case 2:
                        playbackInfo = _f.sent();
                        if (startPlayback) {
                            this.startPlayback(playbackInfo, data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _f.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, false];
                }
            });
        });
    };
    // Internal Playback State
    PlaybackManager.prototype.startPlayback = function (track, media) {
        var _this = this;
        var _a = this.getTrackUrl(track), url = _a.url, oringial_duration = _a.duration, preview = _a.preview;
        if (url) {
            var additional_Info = {};
            if (oringial_duration) {
                additional_Info.duration = oringial_duration;
            }
            this.setPlaybackState(Object.assign({}, this.playbackState, {
                media: Object.assign({}, media, __assign({ playbackInfo: track }, additional_Info)),
            }), media);
            var play = function (url) { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    this._internalPlayer && this._internalPlayer.play({
                        url: url, totalDuration: oringial_duration, isPreview: preview,
                        onError: function (type, data) { return __awaiter(_this, void 0, void 0, function () {
                            var available, error_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(type == 'FileNotFound')) return [3 /*break*/, 6];
                                        if (!this._cookieProvider) return [3 /*break*/, 5];
                                        return [4 /*yield*/, this._cookieProvider.isSet()];
                                    case 1:
                                        available = _a.sent();
                                        if (!!available) return [3 /*break*/, 5];
                                        this.setPlaybackState(Object.assign({}, this.playbackState, {
                                            state: PlayerState.Loading
                                        }), media);
                                        _a.label = 2;
                                    case 2:
                                        _a.trys.push([2, 4, , 5]);
                                        return [4 /*yield*/, this._cookieProvider.set()];
                                    case 3:
                                        _a.sent();
                                        this._cookieProvider.isSet();
                                        return [2 /*return*/, this.startPlayback(track, media)];
                                    case 4:
                                        error_2 = _a.sent();
                                        this.setPlaybackState(Object.assign({}, this.playbackState, {
                                            state: PlayerState.Error
                                        }), media);
                                        return [2 /*return*/, false];
                                    case 5:
                                        if (track.forceMP3 == undefined && !this.isPlayingVideo()) {
                                            track.forceMP3 = true;
                                            return [2 /*return*/, this.startPlayback(track, media)];
                                        }
                                        else {
                                            this.setPlaybackState(Object.assign({}, this.playbackState, {
                                                state: PlayerState.Error
                                            }), media);
                                            return [2 /*return*/, false];
                                        }
                                        return [3 /*break*/, 7];
                                    case 6:
                                        this.setPlaybackState(Object.assign({}, this.playbackState, {
                                            state: PlayerState.Error
                                        }), media);
                                        return [2 /*return*/, false];
                                    case 7: return [2 /*return*/];
                                }
                            });
                        }); },
                        onPlay: function (trackDuration) {
                            if (!oringial_duration)
                                _this.setPlaybackState(Object.assign({}, _this.playbackState, {
                                    duration: trackDuration
                                }), media);
                        },
                        onProgress: function (progress, trackDuration) {
                            console.log(progress);
                            _this.setPlaybackState(Object.assign({}, _this.playbackState, {
                                progress: progress,
                                duration: oringial_duration || trackDuration
                            }), media);
                        },
                        onStateChange: function (state) {
                            _this.setPlaybackState(Object.assign({}, _this.playbackState, {
                                state: state
                            }), media);
                        },
                        onEnd: function (target) {
                            var _a, _b, _c;
                            PlaybackManager.getPlaybackInfo && PlaybackManager.getPlaybackInfo((_b = (_a = _this.playbackState) === null || _a === void 0 ? void 0 : _a.media) === null || _b === void 0 ? void 0 : _b.track.id, (_c = _this.playbackState) === null || _c === void 0 ? void 0 : _c.progress);
                            _this.setPlaybackState(Object.assign({}, _this.playbackState, {
                                progress: 0,
                            }), media);
                            if (!_this.autorepeat) {
                                var result = _this.forward();
                                if (!result) {
                                    _this.setPlaybackState(Object.assign({}, _this.playbackState, {
                                        state: PlayerState.None
                                    }), media);
                                }
                            }
                            else {
                                _this.rewind(true);
                            }
                        }
                    });
                    return [2 /*return*/];
                });
            }); };
            play(url);
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * This function retrieves the appropriate content url for a track based on content type and the available quality
     * @param info
     */
    PlaybackManager.prototype.getTrackUrl = function (info) {
        if (info.audioInfo) {
            return {
                url: info.audioInfo[(this.hq && info.audioInfo.hq) ? 'hq' : 'lq'][(info.forceMP3 || !Player.hlsSupported()) ? 'mp3' : 'hls'] || info.audioInfo[(this.hq && info.audioInfo.hq) ? 'hq' : 'lq'].mp3,
                duration: info.audioInfo.meta ? (info.audioInfo.meta.is_preview ? info.audioInfo.meta.original_track_duration : undefined) : undefined,
                preview: info.audioInfo.meta ? info.audioInfo.meta.is_preview : false
            };
        }
        else if (info.videoInfo) {
            return { url: info.videoInfo['hq'] && info.videoInfo['hq'].mp4 || undefined, duration: undefined, preview: false };
        }
        else {
            return { url: undefined, duration: undefined, preview: false };
        }
    };
    // Playback Actions
    /**
     * This function pauses the currently playing track
     * @param cb - Called after pausing the track
     */
    PlaybackManager.prototype.pause = function (cb) {
        this._internalPlayer && this._internalPlayer.pause(cb);
    };
    /**
     * This function resumes or starts playback at the start of the currently active list depending on the current playback state
     */
    PlaybackManager.prototype.play = function () {
        if (this.playbackState && this.playbackState.media) {
            if (this.playbackState.media.playbackInfo) {
                this.startPlayback(this.playbackState.media.playbackInfo, this.playbackState.media);
            }
            else {
                this.startTrack(this.playbackState.media, undefined, true);
            }
        }
        else {
            this.forward();
        }
    };
    /**
     * This function stops the player and resets the players state
     */
    PlaybackManager.prototype.stop = function () {
        this._internalPlayer && this._internalPlayer.stop();
        this.setPlaybackState({ state: PlayerState.None }, undefined, true);
    };
    /**
     * This function skips to the next song if the player is already playing or starts the next track if nothing is playing yet
     */
    PlaybackManager.prototype.forward = function () {
        var playingTrack = this.getTrack();
        if (playingTrack) {
            var nextTrack = this._playbackContentManager.getTrackAfter(playingTrack);
            if (nextTrack) {
                this.startTrack(nextTrack, undefined, true);
                return true;
            }
        }
        else {
            var nextTrack = this._playbackContentManager.getTrackAfter(playingTrack);
            if (nextTrack) {
                this.startTrack(nextTrack, undefined, true);
                return true;
            }
        }
        return false;
    };
    /**
     * This function rewinds the current song to the start if playback has occurred for more than 4 seconds or plays the previous song if playback has occurred for less than 4 seconds
     * @param forcePlay - If provided, the track is automatically started after rewinding from a stopped state
     */
    PlaybackManager.prototype.rewind = function (forcePlay) {
        if (forcePlay === void 0) { forcePlay = false; }
        if (this._playbackState && this._playbackState.progress && this._playbackState.progress > 4 || forcePlay) {
            this.seek(0);
            if (forcePlay) {
                this.play();
            }
            return;
        }
        var playingTrack = this.getTrack();
        if (playingTrack) {
            var nextTrack = this._playbackContentManager.getTrackBefore(playingTrack);
            if (nextTrack) {
                this.startTrack(nextTrack, undefined, this.playbackState && this.playbackState.state !== PlayerState.Paused);
            }
        }
    };
    /**
     * Seeks the track to the specified duration
     * @param to
     */
    PlaybackManager.prototype.seek = function (to) {
        this._internalPlayer && this._internalPlayer.seek(to);
        this.setPlaybackState(Object.assign({}, this.playbackState, {
            progress: to
        }), this.playbackState && this.playbackState.media, true);
    };
    // Getters
    /**
     * The current instance that manages internal playback state
     */
    PlaybackManager.prototype.getContentManager = function () {
        return this._playbackContentManager;
    };
    /**
     * The current state of playback
     */
    PlaybackManager.prototype.getPlayingState = function () {
        if (this.playbackState) {
            return this.playbackState.state;
        }
        return PlayerState.None;
    };
    /**
     * The currently active track information
     */
    PlaybackManager.prototype.getTrack = function () {
        var state = this.playbackState;
        return state ? state.media : undefined;
    };
    /**
     * Checks if the provided track from the provided list is currently playing
     * @param track
     * @param playlist
     */
    PlaybackManager.prototype.isPlayingTrack = function (track, playlist) {
        var playingTrack = this.getTrack();
        return playingTrack && playingTrack.track.id === track.id && playingTrack.playlist.isEqual(playlist);
    };
    /**
     * Checks if the provided album from the provided list is currently playing
     * @param album
     * @param playlist
     */
    PlaybackManager.prototype.isPlayingAlbum = function (album, playlist) {
        var playingTrack = this.getTrack();
        return playingTrack && playingTrack.album.id === album.id && playingTrack.playlist.isEqual(playlist);
    };
    /**
     * Checks if the player is currently playing video
     */
    PlaybackManager.prototype.isPlayingVideo = function () {
        var state = this.playbackState;
        if (state) {
            return state.media_type === 'video';
        }
        return false;
    };
    /**
     * Returns the current playback progress
     */
    PlaybackManager.prototype.getProgress = function () {
        return (this.playbackState ? this.playbackState.progress : 0) || 0;
    };
    /**
     * Returns the duration of the active track
     */
    PlaybackManager.prototype.getDuration = function () {
        return this.playbackState && this.playbackState.duration;
    };
    // Configuration
    /**
     * Sets the cookied provider to use when streaming songs
     */
    PlaybackManager.prototype.setCookieProvider = function (provider) {
        this._cookieProvider = provider;
    };
    Object.defineProperty(PlaybackManager.prototype, "playbackConfig", {
        /**
         * Returns the active playback configuration
         */
        get: function () {
            return this._playbackConfig;
        },
        /**
         * Sets the active playback configuration
         */
        set: function (newValue) {
            this._playbackConfig = newValue;
            this.callPlaybackConfigListeners(newValue);
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    PlaybackManager.prototype.setPlaybackState = function (newValue, forMedia, force) {
        if (force === void 0) { force = false; }
        if (forMedia && newValue && this._playbackState && this._playbackState.media && this._playbackState.media.track.id === forMedia.track.id) {
            //Do not reset progress ist ths trackid dosent changed!
            if (newValue && newValue.progress == undefined && this._playbackState && this._playbackState.progress !== undefined) {
                newValue.progress = this._playbackState.progress;
            }
            var prevValue = this._playbackState;
            this._playbackState = newValue;
            this.callPlaybackStateListeners(newValue, newValue.state !== prevValue.state);
        }
        else if (forMedia == undefined && newValue == undefined) {
            this._playbackState = newValue;
            this.callPlaybackStateListeners(newValue, true);
        }
        else if (forMedia && newValue && !this._playbackState) {
            this._playbackState = newValue;
            this.callPlaybackStateListeners(newValue, true);
        }
        else if (force) {
            this._playbackState = newValue;
            this.callPlaybackStateListeners(newValue, true);
        }
    };
    ;
    Object.defineProperty(PlaybackManager.prototype, "playbackState", {
        /**
         * Returns the current playback state
         */
        get: function () {
            return this._playbackState;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(PlaybackManager.prototype, "autorepeat", {
        /**
         * Returns the current autorepeate mode
         */
        get: function () {
            return this.playbackConfig.autorepeat;
        },
        /**
         * Sets the auto repeat mode and saves it to local storage
         */
        set: function (newValue) {
            this.playbackConfig.autorepeat = newValue;
            localStorage[AUTOREPLAY_KEY] = (newValue ? 'true' : 'false');
            // BPMEventHandler.getInstance().callOnEvent({ object: Objects.AUTO_REPEATE });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlaybackManager.prototype, "shuffle", {
        /**
         * Returns the current shuffle mode
         */
        get: function () {
            return this.playbackConfig.shuffle;
        },
        /**
        * Sets the shuffle mode and saves it to local storage
        */
        set: function (newValue) {
            this.playbackConfig.shuffle = newValue;
            localStorage[SHUFFLE_KEY] = (newValue ? 'true' : 'false');
            this._playbackContentManager.setPlaybackMode(this.shuffle ? 'shuffle' : 'serial');
            // BPMEventHandler.getInstance().callOnEvent({ object: Objects.SHUFFLE });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlaybackManager.prototype, "hq", {
        /**
         * Returns the current hq mode
         */
        get: function () {
            return this.playbackConfig.hq;
        },
        /**
        * Sets the hq mode and saves it to local storage
        */
        set: function (newValue) {
            var doRestart = this.playbackConfig.hq != newValue;
            this.playbackConfig.hq = newValue;
            if (doRestart) {
                this.play();
            }
            if (this.storeHQConfig)
                localStorage[HQ_KEY] = (newValue ? 'true' : 'false');
        },
        enumerable: true,
        configurable: true
    });
    // Listeners
    /**
     * Registers a listener for changes in the current playback configuration
     * @param listener
     */
    PlaybackManager.prototype.addPlaybackConfigListener = function (listener) {
        var id = uuidv4();
        this._playbackConfigListeners[id] = listener;
        return id;
    };
    /**
     * Removes a playback configuration listener
     * @param id
     */
    PlaybackManager.prototype.removePlaybackConfigListener = function (id) {
        delete this._playbackConfigListeners[id];
    };
    PlaybackManager.prototype.callPlaybackConfigListeners = function (config) {
        var _this = this;
        Object.keys(this._playbackConfigListeners).map(function (key) { return _this._playbackConfigListeners[key]; }).forEach(function (cb) {
            cb(config);
        });
    };
    /**
     * Registers a listener for changes in the current playback state
     * @param listener
     */
    PlaybackManager.prototype.addPlaybackStateListener = function (listener) {
        var id = uuidv4();
        this._playbackStateListeners[id] = listener;
        return id;
    };
    /**
     * Registers a listener for changes in the current playback progress
     * @param listener
     */
    PlaybackManager.prototype.addPlaybackProgressStateListener = function (listener) {
        var id = uuidv4() + '_progress';
        this._playbackStateListeners[id] = listener;
        return id;
    };
    /**
     * Removes a playback state / progress listener
     * @param listener
     */
    PlaybackManager.prototype.removePlaybackStateListener = function (id) {
        delete this._playbackStateListeners[id];
    };
    PlaybackManager.prototype.callPlaybackStateListeners = function (config, playbackStateChanged) {
        var _this = this;
        Object.keys(this._playbackStateListeners).map(function (key) { return [key, _this._playbackStateListeners[key]]; }).forEach(function (data) {
            var key = data[0], cb = data[1];
            if (playbackStateChanged || key.endsWith('_progress')) {
                cb(config);
            }
        });
    };
    PlaybackManager.prototype.getNavigator = function () {
        return this._navigator;
    };
    PlaybackManager.prototype.setNavigator = function (navigator) {
        this._navigator = navigator;
    };
    // List Utils
    /**
     * Replaces the current playback queue with a single list
     * @param list
     * @param mode
     */
    PlaybackManager.prototype.setList = function (list, mode) {
        this._playbackContentManager.replaceLists(list);
        this.shuffle = mode === 'shuffle';
    };
    return PlaybackManager;
}());
export default PlaybackManager;
//# sourceMappingURL=PlaybackManager.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/player/PlaybackManager.js
// module id = 113
// module chunks = 0